'use client'

import BreakingNewsBar from '@/components/BreakingNewsBar'

type News = {
  id: number
  title: string
  slug: string
  createdAt?: string | Date | null
  category: { slug: string } | null
}

/**
 * SSR ile ilk haber HTML’de — ssr:false boş kırmızı şerit pop’unu önler.
 */
export default function BreakingNewsBarLazy({ news }: { news: News[] }) {
  return <BreakingNewsBar news={news} />
}
